import {useMemo} from "react";
import {isSaasLocation} from "../constants/locations";
import {RootStateLocation} from "../store/types";
import {MonolithLocationFields} from "@services/graphql/queries/location";

const useIsSaasLocation = (location?: RootStateLocation | MonolithLocationFields) =>
  useMemo(() => location && isSaasLocation(location), [location]);

export default useIsSaasLocation;
